import "./styles.css";

import GifHome from "./GifHome/Gif.js";
import Servicios from "./Servcios/Servicios.jsx";
import Tarjeta from "../Tarjeta/Tarjeta.js";
import FadeInSection from "../FadeInSection/FadeInSection";

import { useServiciosCombinados } from "../../hook/useServiciosCombinados";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useConvertor } from "../../hook/useConversor.js";
import { useMoneda } from "../../context/MonedaContext.js";

const Home = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { combinados, cargando, error } = useServiciosCombinados();
  const PodriaInteresarte = [combinados[0], combinados[5], combinados[8]];
  const {moneda} = useMoneda();
  const {preciosConvertidos} = useConvertor(combinados,moneda)

  if (cargando) return <p className="cargando">Cargando...</p>;
  if (error) return <p className="error">Error: {error}</p>;
  return (
    <div className="jbHome">
      <FadeInSection>
        <GifHome />
      </FadeInSection>

      <FadeInSection>
        <section className="jbIntroduccion">
          <h1 className="jbTituloIntro">{t("HomeIntro.TituloIntro")}</h1>
          <p className="jbDescripcionIntro"> {t("HomeIntro.mensajeInicio")} </p>
        </section>
      </FadeInSection>

      <FadeInSection>
        <Servicios />
      </FadeInSection>

      <FadeInSection>
        <section className="jbPodriaInteresarte">
          <h1 className="jbPITitulo">{t("HomeIntro.PITitulo")}</h1>
          <div className="jbContenedorTarjetas">
            {PodriaInteresarte.map((servicio) => (
              <Tarjeta key={servicio.id} servicio={{
                ...servicio,
                precioConvertido: preciosConvertidos[servicio.id]
              }} 
              moneda={moneda}
              />
            ))}
          </div>
        </section>
      </FadeInSection>

      <FadeInSection>
        <section className="tpsobreMi">
          <h1>¿Quien soy?</h1>
          <p>
            <b>Te invito a conocernos</b>
            <br />
            Amo la vida en movimiento.
            <br />
            La fluidez es parte de mi camino, y sé que cada experiencia llega
            para enseñarnos algo y ayudarnos a crecer.
            <br />
            Me encanta la naturaleza, la Tierra Madre, el universo... ese gran
            proveedor que nos sostiene en esta existencia.
            <br />
            Te invito a reconectar con lo que te rodea.
            <br />A verlo con nuevos ojos.
            <br />
            Conozco caminos hermosos, y si lo sentís… son para compartirlos con
            vos.
            <br />
            🕊 Te espero, bello pajarito...
            <br />
            Para que despliegues tus alas.
          </p>
          <button onClick={() => navigate("/sobreMi")}>Conocer más</button>
        </section>
      </FadeInSection>
    </div>
  );
};

export default Home;
